module.exports = __webpack_public_path__ + "img/Slide22.69dc9489.png";